import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HelloWorldContComponent } from './hello-world-cont.component';
import { HelloWorldPresModule } from '../presenter';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [HelloWorldContComponent],
  imports: [
    RouterModule.forChild([{ path: '', component: HelloWorldContComponent }]),
    CommonModule,
    HelloWorldPresModule,
  ],
  exports: [HelloWorldContComponent],
})
export class HelloWorldContModule {}
